import {
  LIST_MCU_PROJECT_SLA_CONFIGURATION_REQUEST,
  LIST_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS,
  LIST_MCU_PROJECT_SLA_CONFIGURATION_FAIL,
  DETAIL_MCU_PROJECT_SLA_CONFIGURATION_REQUEST,
  DETAIL_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS,
  DETAIL_MCU_PROJECT_SLA_CONFIGURATION_FAIL,
  CREATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST,
  CREATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS,
  CREATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL,
  UPDATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST,
  UPDATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS,
  UPDATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL,
  DELETE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST,
  DELETE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS,
  DELETE_MCU_PROJECT_SLA_CONFIGURATION_FAIL
} from '../../constants/mcu-project-sla-configuration'

const initialState = {
  slaConfigurations: [],
  slaConfiguration: {},
  pageable: {
    page: 1,
    size: 10,
    total: 0,
    hits: 0
  },
  loadingList: false,
  loadingDetail: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  error: null
}

const mcuProjectSlaConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_SLA_CONFIGURATION_REQUEST:
      return { ...state, loadingList: true, error: null }
    case LIST_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingList: false,
        slaConfigurations: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_MCU_PROJECT_SLA_CONFIGURATION_FAIL:
      return {
        ...state,
        loadingList: false,
        slaConfigurations: [],
        error: action.payload
      }
    case DETAIL_MCU_PROJECT_SLA_CONFIGURATION_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        slaConfiguration: {},
        error: null
      }
    case DETAIL_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        slaConfiguration: action.payload,
        error: null
      }
    case DETAIL_MCU_PROJECT_SLA_CONFIGURATION_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case CREATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST:
      return { ...state, loadingCreate: true, error: null }
    case CREATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS:
      return { ...state, loadingCreate: false, error: null }
    case CREATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case UPDATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST:
      return { ...state, loadingUpdate: true, error: null }
    case UPDATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS:
      return { ...state, loadingUpdate: false, error: null }
    case UPDATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST:
      return { ...state, loadingDelete: true, error: null }
    case DELETE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        slaConfigurations: state.slaConfigurations.filter(
          (item) => item?.id !== action.payload
        ),
        error: null
      }
    case DELETE_MCU_PROJECT_SLA_CONFIGURATION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    default:
      return state
  }
}

export default mcuProjectSlaConfigurationReducer
